import React from 'react';

const IconCheckMark = (props) => {

  return (
    <svg {...props} width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.20711 6.29289C1.81658 5.90237 1.18342 5.90237 0.792893 6.29289C0.402369 6.68342 0.402369 7.31658 0.792893 7.70711L2.20711 6.29289ZM7.5 13L6.79289 13.7071C6.99534 13.9096 7.27486 14.0155 7.56064 13.9982C7.84642 13.9808 8.11105 13.8418 8.28751 13.6163L7.5 13ZM17.2875 2.11631C17.6279 1.68138 17.5512 1.05287 17.1163 0.712495C16.6814 0.372117 16.0529 0.448765 15.7125 0.883692L17.2875 2.11631ZM0.792893 7.70711L6.79289 13.7071L8.20711 12.2929L2.20711 6.29289L0.792893 7.70711ZM8.28751 13.6163L17.2875 2.11631L15.7125 0.883692L6.71249 12.3837L8.28751 13.6163Z" fill="#6F9AA6"/>
    </svg>
  );
}

export default IconCheckMark;